import React from 'react';
import styles from './StatusBadge.module.scss';

export type BadgeVariant = 'success' | 'error' | 'info' | 'warning' | 'neutral';

interface StatusBadgeProps {
  variant: BadgeVariant;
  children: React.ReactNode;
}

export default function StatusBadge({ variant, children }: StatusBadgeProps) {
  return <span className={`${styles.badge} ${styles[variant]}`}>{children}</span>;
}
